class KsfPackageContent extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced === 'true') {
      return;
    }

    this.dataset.enhanced = 'true';
    const content = this.querySelector('.ksf-package-panel__main');

    if (!content) {
      return;
    }

    const sizeHeadings = Array.from(content.children).filter((element) => {
      const isHeading = element.tagName === 'H4';
      const isBoldParagraph = element.tagName === 'P' && element.children.length === 1 && element.firstElementChild?.tagName === 'STRONG';

      return (isHeading || isBoldParagraph) && ['UL', 'OL'].includes(element.nextElementSibling?.tagName);
    });

    if (sizeHeadings.length > 1) {
      this.createSizeAccordions(content, sizeHeadings);
    } else {
      content.querySelectorAll(':scope > ul, :scope > ol').forEach((list) => {
        list.classList.add('ksf-package-panel__list');
      });
    }
  }

  createSizeAccordions(content, headings) {
    const sizes = document.createElement('div');
    sizes.className = 'ksf-package-sizes';
    headings[0].before(sizes);

    headings.forEach((heading, index) => {
      const list = heading.nextElementSibling;

      if (!list || !['UL', 'OL'].includes(list.tagName)) {
        return;
      }

      const details = document.createElement('details');
      details.className = 'ksf-package-size';
      details.open = index === 0;

      const summary = document.createElement('summary');
      summary.className = 'ksf-package-size__summary';

      const label = document.createElement('span');
      label.textContent = heading.textContent.trim();

      const toggle = document.createElement('span');
      toggle.className = 'ksf-package-size__toggle';
      toggle.setAttribute('aria-hidden', 'true');

      const body = document.createElement('div');
      body.className = 'ksf-package-size__body';
      list.classList.add('ksf-package-panel__list');

      summary.append(label, toggle);
      body.append(list);
      details.append(summary, body);
      sizes.append(details);
      heading.remove();

      details.addEventListener('toggle', () => {
        if (!details.open) {
          return;
        }

        sizes.querySelectorAll('.ksf-package-size[open]').forEach((otherDetails) => {
          if (otherDetails !== details) {
            otherDetails.open = false;
          }
        });
      });
    });
  }
}

if (!customElements.get('ksf-package-content')) {
  customElements.define('ksf-package-content', KsfPackageContent);
}
